/* ==========================================================================
   Koolseed — "Nasıl Hazırlanır" sekmeleri

   Koolseed yalnızca içecek değil; yoğurda karışıyor, keke giriyor. Bölüm
   birkaç hazırlama yolu gösteriyor: sekmeye basıldığında hem adımlar hem
   görsel o yola geçiyor.

   Sunucudan bütün yollar basılıyor, sekme yalnızca hangisinin görüneceğini
   seçiyor — JS çalışmazsa hepsi alt alta okunabilir kalıyor.
   ========================================================================== */

(function () {
  'use strict';

  class KsHowto extends HTMLElement {
    connectedCallback() {
      this.tabs = Array.from(this.querySelectorAll('[data-howto-tab]'));
      if (this.tabs.length < 2) return;

      this.panels = Array.from(this.querySelectorAll('[data-howto-panel]'));
      this.shots = Array.from(this.querySelectorAll('[data-howto-shot]'));

      this.addEventListener('click', (event) => {
        const tab = event.target.closest('[data-howto-tab]');
        if (tab && this.contains(tab)) this.select(tab.dataset.howtoTab);
      });

      // Sol/sağ okla sekmeler arasında gezinme.
      this.addEventListener('keydown', (event) => {
        if (event.key !== 'ArrowRight' && event.key !== 'ArrowLeft') return;
        const current = this.tabs.indexOf(document.activeElement);
        if (current === -1) return;
        event.preventDefault();
        const step = event.key === 'ArrowRight' ? 1 : -1;
        const next = this.tabs[(current + step + this.tabs.length) % this.tabs.length];
        next.focus();
        this.select(next.dataset.howtoTab);
      });
    }

    select(key) {
      this.tabs.forEach((tab) => {
        const on = tab.dataset.howtoTab === key;
        tab.classList.toggle('is-active', on);
        tab.setAttribute('aria-selected', String(on));
      });
      this.panels.forEach((panel) => { panel.hidden = panel.dataset.howtoPanel !== key; });
      this.shots.forEach((shot) => { shot.hidden = shot.dataset.howtoShot !== key; });
    }
  }

  if (!customElements.get('ks-howto')) customElements.define('ks-howto', KsHowto);
})();
